import { render, staticRenderFns } from "./OpeningHoursContainer.vue?vue&type=template&id=1a9cbcf6&"
import script from "./OpeningHoursContainer.vue?vue&type=script&lang=js&"
export * from "./OpeningHoursContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports